module.exports = __webpack_public_path__ + "static/assets/99608195b9e968030cc16badd0d6e51e.svg";